/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetArticlesListModel,
  IGetArticlesListRequest,
  IMappers,
  IGetArticlesListResponse,
  IGetArticlesListResponseError,
  TGetArticlesListResponse,
} from './types';

const defaultConfig: TGetArticlesListModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'valuation-b2b',
  pathApi: '/v1/get-articles-list/',
  hostType: 'api',
} as TGetArticlesListModel;

function createGetArticlesListModel(parameters: IGetArticlesListRequest): TGetArticlesListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetArticlesListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetArticlesListRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetArticlesList<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetArticlesListOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetArticlesListResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetArticlesListModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetArticlesListResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetArticlesListResponseError);
    }
  }

  return { response, statusCode } as TGetArticlesListResponse;
}

export { defaultConfig, createGetArticlesListModel, fetchGetArticlesList };
